import React from 'react';
import { observer } from 'mobx-react-lite';
import PropTypes from 'prop-types';

import { AutofillButton } from '@ratehub/ins-common';

import PERSONAL_DETAILS_SNAPSHOT from '../../snapshots/PersonalDetails';
import COVERAGE_DETAILS_SNAPSHOT from '../../snapshots/CoverageDetails';
import PAGES from '../definitions/Pages';


function LifeAutofillButton({ viewModel }) {
    return (
        <AutofillButton
            onClick={() => applyPageSnapshot(viewModel)}
        />
    );
}

function applyPageSnapshot(viewModel) {
    let snapshot;

    switch (viewModel.name) {
        case PAGES.COVERAGE_DETAILS.id:
            snapshot = COVERAGE_DETAILS_SNAPSHOT;
            break;

        case PAGES.PERSONAL_DETAILS.id:
            snapshot = PERSONAL_DETAILS_SNAPSHOT;
            break;

        default:
            return;
    }

    viewModel.context.updateJourney(snapshot);
}

LifeAutofillButton.propTypes = {
    viewModel: PropTypes.object.isRequired,
};

export default observer(LifeAutofillButton);
